module.exports = __webpack_public_path__ + "static/img/降价@3x.25f424c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/降价@3x.png
// module id = 0iE+
// module chunks = 192